<section class="payment-form">
  @if (isAmountShown) {
    <div class="payment-form__amount-block">
      <label class="form-label form-label--bold">Payment Amount</label>
      <div class="payment-amount">{{ currencyIcon$ | async }}{{ paymentAmount | cmCurrency }}</div>
    </div>
  }

  @switch (paymentType) {
    @case (PAYMENT_TYPES.STRIPE) {
      <cm-stripe-form [showError]="showError" (formChange)="onPaymentFormChange($event)" />
    }
    @case (PAYMENT_TYPES.PAYFLOW_PRO) {
      <cm-payflow-form (formChange)="onPaymentFormChange($event)" [showError]="showError" />
    }
    @case (PAYMENT_TYPES.SQUARE) {
      <cm-square-form
        #squareForm
        [paymentConfig]="publicSettings.squareConfig"
        (nonceChange)="onSquareChange($event)"
      />
    }
    @case (PAYMENT_TYPES.EXACT) {
      <cm-exact-form
        [paymentConfig]="publicSettings.exactConfig"
        [paymentAmount]="paymentAmount"
        [step]="step"
        [paymentPlace]="place"
        #exactForm
      />
    }
    @case (PAYMENT_TYPES.EPAY) {
      <cm-epay-form #epayForm [paymentAmount]="paymentAmount" [step]="step" [paymentPlace]="place" />
    }
    @case (PAYMENT_TYPES.AUTHORIZE_NET) {
      <cm-authorize-net-form
        #authorizeNetForm
        [paymentConfig]="publicSettings.authorizeNetConfig"
        (formChange)="onPaymentFormChange($event)"
        [showError]="showError"
        (displayError)="displayError($event)"
      />
    }
  }
</section>

<cm-payment-form-error [errors]="errors" />
